import { Grid } from "@mui/material";
import React from "react";
import Paragraph from "../../../atoms/Paragraph";
import Title from "../../../atoms/Title";
import apiIcon from "../../../../Icons/apiIcon.png";
import OAuth2Authentication from "./OAuth2Authentication";

function OAuth2Authenticator({
  serviceAuth,
  setServiceAuth,
  orgId,
  apiKey,
  dataCenterUrl,
  dataCenter,
  zApiKey,
  setSnack,
  submitData,
  currentUser,
  handlefetchConnections,
  settingId,
  service,
}) {
  return (
    <Grid
      container
      sx={{ borderRadius: "8px", border: "1px solid #cccccc", mb: "1rem" }}
    >
      <Grid item xs={6} sx={{ p: "20px" }}>
        <Title>Authenticate {service?.name} Service</Title>
        <Paragraph>
          Cellcast SMS require to fetch/modify Record's Details and fields
          metadata of modules. To perform these, it requires Zoho CRM Service
          authenticate. Please click the button below to Authenticate Zoho CRM
          Service
        </Paragraph>

        <OAuth2Authentication
          serviceAuth={serviceAuth}
          setServiceAuth={setServiceAuth}
          orgId={orgId}
          apiKey={apiKey}
          dataCenterUrl={dataCenterUrl}
          dataCenter={dataCenter}
          zApiKey={zApiKey}
          setSnack={setSnack}
          service={service}
          currentUser={currentUser}
          submitData={submitData}
          settingId={settingId}
          handlefetchConnections={handlefetchConnections}
        />
      </Grid>
      <Grid
        item
        xs={6}
        sx={{ p: "20px", display: "grid", placeItems: "center" }}
      >
        <img
          src={apiIcon}
          alt="api PNG"
          style={{ display: "block", width: 220 }}
        />
      </Grid>
    </Grid>
  );
}

export default OAuth2Authenticator;
